// This file is a duplication of the file next/packages/editor-action-bar/src/editorControlsBannerDismissal.ts in editor-action-bar package.
// Due to circular dependency, we cannot use import from editor-action-bar package.
// If you need to update this file, please update the file in editor-action-bar package and then copy the changes here.
// This file will be removed once we remove editor controls banner from editor-action-bar package.

import {
	confluenceLocalStorageInstance as localStorage,
	PERSISTED_KEYS_ON_SERVER,
} from '@confluence/storage-manager';
import { getLogger } from '@confluence/logger';

const logger = getLogger('EditorControlsBannerDismissal');

export type BannerType = 'toolbar-top' | 'toolbar-inline';
type BannerDismissal = {
	time?: number;
	count?: number;
};

type LocalStorageItem = {
	[key in BannerType]?: BannerDismissal;
};

const NEW_PINNING_STORAGE_KEY =
	PERSISTED_KEYS_ON_SERVER.PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED;

export const getBannerType = (isTopBanner: boolean): BannerType => {
	return isTopBanner ? 'toolbar-top' : 'toolbar-inline';
};

const getLocalStorageItem = (storageKey: string): LocalStorageItem | undefined => {
	try {
		const itemString = localStorage.getItem(storageKey);
		if (!itemString) {
			return undefined;
		}
		const item = JSON.parse(itemString);
		if (
			typeof item === 'object' &&
			item !== null &&
			!Array.isArray(item) &&
			Object.keys(item).every((key) => ['toolbar-top', 'toolbar-inline'].includes(key))
		) {
			return item;
		}
	} catch (error) {
		logger.error`Error parsing local storage key(${storageKey}): ${error}`;
	}
	return undefined;
};

export const isBannerDismissedInLocalStorageNewPinning = (bannerType: BannerType): boolean => {
	const localStorageItem = getLocalStorageItem(NEW_PINNING_STORAGE_KEY);
	if (!localStorageItem || !localStorageItem[bannerType]) {
		return false;
	}
	const dismissal = localStorageItem[bannerType];
	if (dismissal) {
		return true; // we return true if the banner has been dismissed, no more returning
	}
	return false;
};

export const persistBannerDismissalNewPinning = (bannerType: BannerType) => {
	let item = getLocalStorageItem(NEW_PINNING_STORAGE_KEY);
	if (!item) {
		item = { [bannerType]: { time: Date.now(), count: 0 } };
	} else {
		const currentTime = Date.now();
		if (!item[bannerType]) {
			item[bannerType] = { time: currentTime, count: 0 };
		}
	}
	try {
		localStorage.setItem(NEW_PINNING_STORAGE_KEY, JSON.stringify(item));
	} catch (error) {
		logger.error`Error setting local storage key(${NEW_PINNING_STORAGE_KEY}): ${error}`;
	}
};
